import {useEffect, useMemo} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function VehiclesIndividualsData({ data }) {
    const vehiclesDetailsData = useMemo(() => {
        const source = data?.vehicles_details || [];

        return {
            labels: [
                "ID",
                "Agente",
                "Data/hora",
                "Dia da semana",
                "Placa",
                "Cidade da placa",
                "Tipo de veículo",
                "Marca/modelo",
                "Cor",
                "Ano",
            ],
            values: source.map(item => [
                item.id ?? "Não informado",
                item.agent ?? "Não informado",
                item.dt_start ?? "Não informado",
                item.dow ?? "Não informado",
                item.plate ?? "Não informado",
                item.plate_city ?? "Não informado",
                item.vehicle_type ?? "Não informado",
                item.brand_model ?? "Não informado",
                item.color ?? "Não informado",
                item.vehicle_year ?? "Não informado",
            ]),
        };
    }, [data]);

    const individualsDetailsData = useMemo(() => {
        const source = data?.individuals_details || [];

        return {
            labels: [
                "ID",
                "Agente",
                "Data início",
                "Dia da semana",
                "CPF",
                "Nome",
                "Apelido",
                "Sexo",
                "Idade",
                "Endereço",
                "Cidade de nascimento",
            ],
            values: source.map(item => [
                item.id ?? "Não informado",
                item.agent ?? "Não informado",
                item.dt_start ?? "Não informado",
                item.dow ?? "Não informado",
                item.cpf ?? "Não informado",
                item.name_social_name ?? "Não informado",
                item.nickname ?? "Não informado",
                item.sex ?? "Não informado",
                item.age ?? "Não informado",
                item.address ?? "Não informado",
                item.cityofbirth ?? "Não informado",
            ]),
        };
    }, [data]);

    useEffect(() => {
        if (!vehiclesDetailsData.values.length) return;

        ReportUtils.createExportableTable(
            vehiclesDetailsData.labels,
            vehiclesDetailsData.values,
            "Detalhes dos veículos",
        );

        if (!individualsDetailsData.values.length) return;

        ReportUtils.createExportableTable(
            individualsDetailsData.labels,
            individualsDetailsData.values,
            "Detalhes dos indivíduos"
        );
    }, [vehiclesDetailsData, individualsDetailsData]);
}